import { render, staticRenderFns } from "./VNotificationItem.vue?vue&type=template&id=e0a63baa"
import script from "./VNotificationItem.vue?vue&type=script&lang=js"
export * from "./VNotificationItem.vue?vue&type=script&lang=js"
import style0 from "./VNotificationItem.vue?vue&type=style&index=0&id=e0a63baa&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0a63baa')) {
      api.createRecord('e0a63baa', component.options)
    } else {
      api.reload('e0a63baa', component.options)
    }
    module.hot.accept("./VNotificationItem.vue?vue&type=template&id=e0a63baa", function () {
      api.rerender('e0a63baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/common/VNotificationItem.vue"
export default component.exports